<template>
    <div>
        <div class="tab-panel padded text-center">
            <chart :includeTotals="true" path="/api/people/GetChartSales"></chart>
        </div>
    </div>    
</template>

<script>
    import Chart from '@/tools/Chart'

    export default {
        components: {
            Chart,        
        }
    }
</script>


// WEBPACK FOOTER //
// ResourceOverview.vue?466d210b